import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const REGATTA_ROUTES: AppRoutes = [
    {
        path: "twilight-races",
        loadComponent: () => import('./components/regatta-twilight-races/regatta-twilight-races.component').then(mod => mod.RegattaTwilightRacesComponent),
        title: 'Regatta, Twilight-Races',
        data: {
            header: {
                type: 'back_button',
            },
            meta: {
                description: 'Twilight-Races: Regatta-Serie und Clubabende für Alle'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "hall-of-fame",
        loadComponent: () => import('./components/regatta-hall-of-fame/regatta-hall-of-fame.component').then(mod => mod.RegattaHallOfFameComponent),
        title: 'Regatta, Hall of Fame',
        data: {
            header: {
                type: 'back_button',
            },
             meta: {
                description: 'Regatta-Erfolge der YSTM-Segler über die Zeit'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "race-track",
        loadComponent: () => import('./components/regatta-race-track/regatta-race-track.component').then(mod => mod.RegattaRaceTrackComponent),
        title: 'Regatta, Race-Track',
        data: {
            header: {
                type: 'back_button',
            },
             meta: {
                description: 'Rückblick über vom YSTM ausgerichtete Regatten der vergangenen Jahre.'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "",
        loadComponent: () => import('./components/regatta-carousel/regatta-carousel.component').then(mod => mod.RegattaCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/regatta-home/regatta-home.component').then(mod => mod.RegattaHomeComponent),
        title: 'YSTM - Regatta',
        data: {
            meta: {
                description: 'regelmäßige Regatten im YSTM, P-Boot, R-Boot, H-Jolle, FD, Katamaran, Topcat, A-Cat, Dart, Tornado, Hobie, ILCA, Opti, 29er, Windsurfen, Regatten, Kran'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];